export { useGetNavigateToTeamsApp } from '../src/useGetNavigateToTeamsApp';
